import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';


export default function Logout() {
    const goto = useNavigate();

    useEffect(() => {
        localStorage.clear();
        goto('/login');
    });

  return (
    <></>
  )
}
